export const createFetchMediaPlansFunction = (
  getMediaPlansList,
  setMediaPlans,
  setPage,
  setTotalPages,
  setTotalItems,
  setHasMore,
  setDataLoaded,
  setLoading,
  setIsLoadingMore,
  gridApiRef,
  pendingRequestRef,
  selectedClients
) => {
  return async (
    page = 1,
    pageSize = 50,
    isCalendar = false,
    filters = {}
  ) => {
    try {
      setLoading(true);

      // cancel any pending request (avoid duplicate calls)
      if (pendingRequestRef.current) {
        pendingRequestRef.current.cancelled = true;
      }
      const requestKey = Symbol("mediaPlansRequest");
      pendingRequestRef.current = { key: requestKey, cancelled: false };

      // Call API with filters
      const response = await getMediaPlansList(
        selectedClients.length ? selectedClients : ["all"],
        page,
        pageSize,
        isCalendar ? "calendar" : "list",
        filters.startDate || null,
        filters.endDate || null,
        filters
      );

      if (pendingRequestRef.current.key !== requestKey) {
        // This request is outdated
        return;
      }

      const data = response.data || {};
      setMediaPlans(data.results || []);
      setPage(page);
      setTotalPages(data.total_pages || 0);
      setTotalItems(data.total || 0);
      setHasMore((data.total_pages || 0) > page);
      setDataLoaded(true);

      if (gridApiRef.current) {
        gridApiRef.current.hideOverlay();
      }
    } catch (error) {
      console.error("Error fetching media plans:", error);
    } finally {
      setLoading(false);
      setIsLoadingMore(false);
    }
  };
};
